import React from "react";
import { Card, Result, Button } from "antd";
import { Link } from "react-router-dom";

export default function AccessDenied() {
  return (
    <Card bordered={false}>
      <Result
        status="403"
        title="Access denied"
        subTitle="Your tenant does not have access to this module."
        extra={[
          <Button key="back" onClick={() => window.history.back()}>
            Go back
          </Button>,
          <a key="request" href="mailto:support@engineers-oncall.co.za">
            Request access
          </a>,
        ]}
      />
    </Card>
  );
}
